<gea-shop-size-detector></gea-shop-size-detector>
<header>
  <a class="skip-link" href="#main-content">Zum Inhalt springen</a>
  <gea-shop-navigation [cmsResponse]="cmsResponse()"></gea-shop-navigation>
</header>
<gea-shop-structured-data-organization />
<gea-shop-spinner></gea-shop-spinner>
<main id="main-content" class="container root-container">
  @if (serverErrorService.active()) {
    <gea-shop-server-error></gea-shop-server-error>
  } @else {
    <router-outlet></router-outlet>
  }
</main>
<gea-toasts aria-live="polite" aria-atomic="true"></gea-toasts>
<gea-shop-footer [cmsResponse]="cmsResponse()"></gea-shop-footer>